import './Blogs.scss';
import Carousel from '../utils/Carousel';
import ProfilePic from "../../images/Ellipse_170.png"
import Image1 from "../../images/Rectangle_1325.png"
import Image2 from "../../images/Rectangle_1326.png"
import Image3 from "../../images/Rectangle_1327.png"
import TalentCard from './TalentCard';
import Header from '../utils/Header';
import LeftArrow from '../../images/left-arrow-white.png';
import RightArrow from '../../images/right-arrow-white.png';
import toList from '../utils/ComponentUtil';

function Blogs({style={}}) {
    const talents = [{
        image: Image1,
        title: 'Design',
        desc: 'A Digital Nudge For Sustainable Living',
        allDesc: 'As a business owner or manager, what would it look like to have as the data entry',
        profilePic: ProfilePic,
        profileName: 'Kaira,  01 June 2022',
        readMore: true,
        to: '/blogs/blog-id'
    },
    {
        image: Image2,
        title: 'Technology',
        desc: 'A Digital Nudge For Sustainable Living',
        allDesc: 'As a business owner or manager, what would it look like to have as the data entry',
        profilePic: ProfilePic,
        profileName: 'Kaira,  01 June 2022',
        readMore: true,
        to: '/blogs/blog-id'
    },
    {
        image: Image3,
        title: 'Art',
        desc: 'A Digital Nudge For Sustainable Living',
        allDesc: 'As a business owner or manager, what would it look like to have as the data entry',
        profilePic: ProfilePic,
        profileName: 'Kaira,  01 June 2022',
        readMore: true,
        to: '/blogs/blog-id'
    }
    ];
    return (
        <div className="blogs-wrp wrapper" id="blogs" style={style}>
            <div className='blogs-content-wrp'>
                <Header title='Blogs' subTitle='Design, Art and Technologies. Read some fresh blogs' />
                <div className="blogs-content">
                    <Carousel numberOfCards={3} partialVisbile={true} leftArrow={LeftArrow} rightArrow={RightArrow}
                        cards={toList([...talents, ...talents], TalentCard)}
                    ></Carousel>
                </div>
            </div>
        </div>
    );
}

export default Blogs;